import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function TeenpattiQueenTopOpen() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "teen41";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
       gameName={"Queen Top Open Teenpatti"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container teenpatti2"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
            Queen Top Open Teenpatti
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span>
          <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>159250501130137</span>
            </small>
          </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none"> */}
      {/* <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>159250501130137</span>
            </span>
          </div> */}
      {/* </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/teen41/a37b99e7-d958-4c2b-abea-4ddc2b88ac0b?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="casino-video-cards">
              <div className="">
                <h5>Player A</h5>
                <div className="flip-card-container">
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/QSS.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/QSS.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/JHH.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/JHH.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/9DD.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/9DD.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-1">
                <h5>Player B</h5>
                <div className="flip-card-container">
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">8</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">8</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-table-left-box">
              <div className="casino-table-header">
                <div className="casino-nation-detail">Player A</div>
                <div className="casino-odds-box back">Back</div>
                <div className="casino-odds-box lay">Lay</div>
              </div>
              <div className="casino-table-body">
                <div className="casino-table-row ">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Main
                      <p className="casino-nation-book text-center d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "Player A")}
                      </p>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back suspended-box"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player A", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box lay suspended-box"> */}
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player A", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player A", casinoData, false)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-table-box-divider" />
            <div className="casino-table-right-box">
              <div className="casino-table-header">
                <div className="casino-nation-detail">Player B</div>
                <div className="casino-odds-box back">Back</div>
                <div className="casino-odds-box lay">Lay</div>
              </div>
              <div className="casino-table-body">
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Main
                      <p className="casino-nation-book text-center d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "Player B")}
                      </p>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player B", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box lay"> */}
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player B", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player B", casinoData, false)}
                    </span>
                  </div>
                </div>
                <div className="casino-table-row under-over-row">
                  <div className="uo-box">
                    <div className="casino-nation-detail">
                      <div className="casino-nation-name">
                        Player B Under 21
                        <p className="casino-nation-book text-center d-none d-md-block w-100">
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Player B Under 21"
                          )}
                        </p>
                      </div>
                    </div>
                    {/* <div className="casino-odds-box back"> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet(
                          "Player B Under 21",
                          casinoData,
                          dispatch,
                          "back"
                        )
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player B Under 21", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className="uo-box">
                    <div className="casino-nation-detail">
                      <div className="casino-nation-name">
                        Player B Over 21
                        <p className="casino-nation-book text-center d-none d-md-block w-100">
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Player B Over 21"
                          )}
                        </p>
                      </div>
                    </div>
                    {/* <div className="casino-odds-box back"> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Player B Over 21", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player B Over 21", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/teen41">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-a">A</span>
              <span className="result result-a">A</span>
              <span className="result result-b">B</span>
              <span className="result result-b">B</span>
              <span className="result result-b">B</span>
              <span className="result result-b">B</span>
              <span className="result result-a">A</span>
              <span className="result result-b">B</span>
              <span className="result result-a">A</span>
              <span className="result result-a">A</span>
            </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
